import React from 'react';
export const CategoriesType = (props) => {
    if (props.statTypesData.length === 0) {
        return null;
    }
    return <div className='line-base-filter'>
      <div className='line-base-filter-items'>
         {props.statTypesData.map((state) => (<div key={state.name} onClick={() => { !state.isDisabled && props.onStatTypeSelect(state.matchId, state.name); }} className={`line-base-filter-item ${state.isSelected ? 'line-base-filter-item_active' : ''} ${state.isDisabled ? 'disabled' : ''}`}>
               {props.toLocale(state.name)}
               {!!state.count && <div className='line-base-filter-item-count'>{state.count}</div>}
            </div>))}
      </div>
   </div>;
};



// WEBPACK FOOTER //
// ./src/web-frontend-components/line/outcomes/additional/categories/Type.jsx